import React from 'react';
import { Loader2, Building2, Home } from 'lucide-react';

export const PredictionsDropdown = ({
  dropdownRef,
  isLoading,
  hasResults,
  inputValue,
  predictions,
  highlightedIndex,
  onSelect
}) => (
  <div
    ref={dropdownRef}
    className="absolute z-50 w-full mt-2 bg-white dark:bg-gray-800 rounded-xl shadow-xl 
      border border-gray-200 dark:border-gray-700 overflow-hidden"
  >
    {isLoading && !hasResults ? (
      <div className="p-4 text-center text-gray-500">
        <Loader2 className="w-5 h-5 animate-spin mx-auto mb-2" />
        <span className="text-sm">Searching...</span>
      </div>
    ) : hasResults ? (
      <div className="max-h-72 overflow-y-auto">
        {/* Locations */}
        {predictions.locations.length > 0 && (
          <div>
            <div className="px-4 py-2 bg-gray-50 dark:bg-gray-700/50 text-xs font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2">
              <Building2 className="w-3.5 h-3.5" />
              Locations
            </div>
            {predictions.locations.map((prediction, index) => (
              <button
                key={prediction.place_id}
                onClick={() => onSelect(prediction)}
                className={`w-full px-4 py-3 text-left hover:bg-red-50 dark:hover:bg-red-900/20 
                  transition-colors flex items-start gap-3 border-b border-gray-100 dark:border-gray-700/50
                  ${highlightedIndex === index ? 'bg-red-50 dark:bg-red-900/20' : ''}`}
              >
                <div className="mt-0.5 p-1.5 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                  <Building2 className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900 dark:text-white truncate">
                    {prediction.structured_formatting?.main_text}
                  </p>
                  <p className="text-sm text-gray-500 truncate">
                    {prediction.structured_formatting?.secondary_text}
                  </p>
                </div>
              </button>
            ))}
          </div>
        )}

        {/* Addresses */}
        {predictions.addresses.length > 0 && (
          <div>
            <div className="px-4 py-2 bg-gray-50 dark:bg-gray-700/50 text-xs font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2">
              <Home className="w-3.5 h-3.5" />
              Addresses
            </div>
            {predictions.addresses.map((prediction, index) => {
              const adjustedIndex = predictions.locations.length + index;
              return (
                <button
                  key={prediction.place_id}
                  onClick={() => onSelect(prediction)}
                  className={`w-full px-4 py-3 text-left hover:bg-red-50 dark:hover:bg-red-900/20 
                    transition-colors flex items-start gap-3 border-b border-gray-100 dark:border-gray-700/50 last:border-b-0
                    ${highlightedIndex === adjustedIndex ? 'bg-red-50 dark:bg-red-900/20' : ''}`}
                >
                  <div className="mt-0.5 p-1.5 bg-green-100 dark:bg-green-900/30 rounded-lg">
                    <Home className="w-4 h-4 text-green-600 dark:text-green-400" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-gray-900 dark:text-white truncate">
                      {prediction.structured_formatting?.main_text}
                    </p>
                    <p className="text-sm text-gray-500 truncate">
                      {prediction.structured_formatting?.secondary_text}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    ) : inputValue.length >= 2 ? (
      <div className="p-4 text-center text-gray-500 text-sm">
        No results found for "{inputValue}"
      </div>
    ) : null}
  </div>
);

export default PredictionsDropdown;
